import React, { Suspense, useEffect, useState } from "react";
import { ErrorFallback } from "@frontend/components/error_fallback";

/**
 * A wrapper that lazily loads Sentry's ErrorBoundary
 */
export function SentryBoundary({ children }: { children: React.ReactNode }) {
    const [SentryModule, setSentryModule] = useState<any>(null);

    useEffect(() => {
        // Dynamic import ensures Sentry isn't in the main bundle/preload unless this is called
        import("@sentry/react").then(setSentryModule);
    }, []);

    if (!SentryModule) {
        return <>{children}</>;
    }

    return (
        <SentryModule.ErrorBoundary
            fallback={<ErrorFallback />}
            beforeCapture={(scope: any) => {
                scope.setTag("level", "top-level");
            }}
        >
            {children}
        </SentryModule.ErrorBoundary>
    );
}
